/* Cloud Object Storage */
export const COLD_VAULT = 2.65914794850004;

export enum USAGE_BACKUP_STORAGE {
  large_500_TB = 500000,
  medium_100_TB = 100000,
  m2_188_TB = USAGE_BACKUP_STORAGE.large_500_TB / COLD_VAULT,
  medium_71_TB = USAGE_BACKUP_STORAGE.m2_188_TB / COLD_VAULT,
  s2_27_TB = USAGE_BACKUP_STORAGE.medium_71_TB / COLD_VAULT,
  small_10_TB = USAGE_BACKUP_STORAGE.s2_27_TB / COLD_VAULT,
}

export enum STORAGE_BUCKET {
  coldVault = 'Vault',
}

export const RATIO_RETRIEIVAL_PERCENTAGE = 5;

export const RATIO_CLASS_A = 100;

export const RATIO_CLASS_B = 100;

export enum RATES {
  storage_per_gb = 0.0063, // COSCVLTSTOR
  retrieval_per_gb = 0.0523, // COSCVLTRTVL
  classA_per_gb = 0.0261, // COSCVLTACALL
  classB_per_gb = 0.0261, // COSCVLTBCALL
}
